// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=19286-101463
// The app's `returnTripOfferSheet` (a bottom sheet) interpreted for the web as the standard
// content modal: title, subtitle and the two modal buttons. Shown via showContentModal when
// the user closes the details of a booking that is eligible for a return trip.
import { useTranslation } from 'react-i18next'
import { ButtonDrawer } from '~/components'
import { getAddressString } from '../BookingDone/BookingDoneHeader'

export default function ReturnTripOffer({ booking, onContinue, onNotNow }) {
  const { t } = useTranslation()
  const destination = getAddressString(booking?.destinationLocation)

  return (
    <>
      <div className="px-4 pt-4 pb-4 pr-12">
        <p className="text-[28px] font-bold leading-none text-on-surface mb-1">
          {t('return-trip-offer-title')}
        </p>
        <p className="text-[17px] leading-[22px] text-on-surface-variant">
          {t('return-trip-offer-subtitle', { destination })}
        </p>
      </div>
      <ButtonDrawer
        modal
        buttons={[
          { title: t('button-not-now'), func: onNotNow },
          { title: t('button-continue'), func: onContinue },
        ]}
      />
    </>
  )
}
